import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'back-side',
  templateUrl: './back-side.component.html',
  styleUrls: ['./back-side.component.css']
})
export class BackSideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
